import { CardNumber } from 'frames-react';
import { useIntl } from 'react-intl';

import { DebitCardFieldWrapper } from '../../DebitCardFieldWrapper';

export const CardNumberField = () => {
    const intl = useIntl();

    return (
        <DebitCardFieldWrapper
            label={intl.formatMessage({
                id: '_.link_debit_card.card_number',
                defaultMessage: 'Card number'
            })}
            htmlFor="cardNumber"
        >
            {/* Stripe adds .StripeElement automatically — CheckoutElement mirrors that so both processors can be styled uniformly */}
            <CardNumber
                className="CheckoutElement"
                data-testid="checkout-card-number"
            />
        </DebitCardFieldWrapper>
    );
};
